import { TipoUpload } from '../../models/enum';

export default function getLabelTipoUpload(tipo?: TipoUpload): string {
  switch (tipo) {
    case TipoUpload.NOTA:
      return 'Nota de Corretagem';
    case TipoUpload.CEI:
      return 'CEI';
    case TipoUpload.NEGOCIACOES_B3:
      return 'Negociações B3';
    case TipoUpload.MOVIMENTACOES_B3:
      return 'Movimentações B3';
    case TipoUpload.POSICOES_B3:
      return 'Posições B3';
    case TipoUpload.JSON_KLAVI:
      return 'Klavi';
    case TipoUpload.JSON_PLUGGY:
      return 'Pluggy';
    default:
      return 'Upload';
  }
}
